import type { JobProgress } from "@entrilia/shared/api/types";
import type { FinishNotification } from "./ContactsJobDialog";

const parseCount = (raw: unknown): number => (typeof raw === "string" ? Number.parseInt(raw, 10) : 0);

export const buildInviteFinishNotification = (progress: JobProgress): FinishNotification => {
  const sent = parseCount(progress.properties["InvitesSent"]);
  const total = progress.totalProgressItems;
  const wasCancelled = progress.properties["Cancelled"] === "true";

  if (wasCancelled) {
    return {
      kind: "success",
      message: `Cancelled. Invitation sent to ${sent} of ${total} ${total === 1 ? "contact" : "contacts"}.`,
    };
  }

  if (progress.isSuccess) {
    return {
      kind: "success",
      message: `Invitation has been sent to ${total} ${total === 1 ? "contact" : "contacts"}`,
    };
  }

  return {
    kind: "error",
    message: `Error occurred when sending the invitation. ${progress.errorMessage ?? ""}`.trim(),
  };
};

export const buildDeleteFinishNotification = (progress: JobProgress): FinishNotification => {
  const deleted = parseCount(progress.properties["ContactsDeleted"]);
  const total = progress.totalProgressItems;
  const wasCancelled = progress.properties["Cancelled"] === "true";

  if (wasCancelled) {
    return {
      kind: "success",
      message: `Cancelled. ${deleted} of ${total} ${total === 1 ? "contact" : "contacts"} deleted.`,
    };
  }

  if (progress.isSuccess && deleted === total) {
    return {
      kind: "success",
      message: `${deleted} ${deleted === 1 ? "contact" : "contacts"} deleted`,
    };
  }

  if (deleted > 0) {
    return {
      kind: "error",
      message:
        `Deleted ${deleted} of ${total} ${total === 1 ? "contact" : "contacts"}. ${progress.errorMessage ?? ""}`.trim(),
    };
  }

  return {
    kind: "error",
    message: `Failed to delete contacts. ${progress.errorMessage ?? ""}`.trim(),
  };
};
